export default __webpack_public_path__ + "static/media/telegram.8a8f9a4e.svg";